import React, { useState, useEffect } from 'react';
import { navLinks } from '../mock';
import { Menu, X, Sparkles } from 'lucide-react';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-[#0a0f1a]/90 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a href="#" className="text-emerald-400 font-bold text-xl tracking-tight">
          Mind to Master
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <button
              key={l.name}
              onClick={() => scrollTo(l.href)}
              className="text-slate-300 hover:text-white text-sm font-medium transition-colors"
            >
              {l.name}
            </button>
          ))}
          <a
            href="/meditation-bundle"
            className="text-amber-300 hover:text-amber-200 text-sm font-semibold transition-colors inline-flex items-center gap-1"
          >
            <Sparkles size={14} /> Meditation Bundle
          </a>
          <button
            onClick={() => scrollTo('#pricing')}
            className="bg-emerald-500 hover:bg-emerald-400 text-slate-900 font-semibold px-5 py-2 rounded-md text-sm transition-colors shadow-lg shadow-emerald-500/20"
          >
            Get Started
          </button>
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a0f1a] border-t border-white/5 px-6 py-4 space-y-3">
          {navLinks.map((l) => (
            <button
              key={l.name}
              onClick={() => scrollTo(l.href)}
              className="block w-full text-left text-slate-300 hover:text-white text-sm font-medium py-2"
            >
              {l.name}
            </button>
          ))}
          <a
            href="/meditation-bundle"
            className="flex items-center gap-1.5 text-amber-300 hover:text-amber-200 text-sm font-semibold py-2"
          >
            <Sparkles size={14} /> Meditation Bundle
          </a>
          <button
            onClick={() => scrollTo('#pricing')}
            className="w-full bg-emerald-500 hover:bg-emerald-400 text-slate-900 font-semibold px-5 py-2.5 rounded-md text-sm"
          >
            Get Started
          </button>
        </div>
      )}
    </header>
  );
}
